export default __webpack_public_path__ + "static/media/photo--lg--118.6ec3d66b.jpg";